(function () {
  var bar = document.querySelector('[data-article-products-sticky]');
  if (!bar) return;

  var KEY = 'ibm-article-sticky-dismissed';

  // Stay dismissed for the rest of the browsing session
  try {
    if (sessionStorage.getItem(KEY) === '1') return;
  } catch (e) {}

  var closeBtn = bar.querySelector('[data-sticky-close]');
  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      bar.setAttribute('hidden', '');
      try {
        sessionStorage.setItem(KEY, '1');
      } catch (e) {}
    });
  }

  // Reveal only after the reader has scrolled into the article a bit
  function onScroll() {
    if (window.scrollY > 400) {
      bar.removeAttribute('hidden');
      window.removeEventListener('scroll', onScroll);
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
